<template>
  <svg width="13" height="12" viewBox="0 0 13 12" fill="none">
    <path d="M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z" fill="#178F7E"/>
    <path d="M12.41 1.41L11 0L5 6L11 12L12.41 10.59L7.83 6L12.41 1.41Z" fill="#178F7E"/>
  </svg>
</template>

<script>
    export default {
        name: 'icon-hide'
    }
</script>